import { useState } from 'react';
import { t } from 'i18next';
import { ChevronDownSmall } from '@peacecover/icon';
import ChatItem from './ChatItem';
import LoadMore from '../../components/cell/LoadMore';
import type { SaleTradingPhotoCardType } from '../types/MarketCardType';

interface ChatListProps {
  tradingPhotoCard: SaleTradingPhotoCardType;
}

const ChatList = ({ tradingPhotoCard }: ChatListProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const chatRooms = tradingPhotoCard.chatRooms ?? [];
  const requestChatCount = chatRooms.filter(
    (chatRoom) => chatRoom.reviewStatus === 'request'
  ).length;
  
  const reviewChats = chatRooms.filter(
    (chatRoom) => chatRoom.reviewStatus === 'received' || chatRoom.reviewStatus === 'pending'
  );

  const hasMultipleChats = chatRooms.length >= 2 && reviewChats.length > 0;

  const handleLoadMoreClick = () => {
    setIsExpanded((prev) => !prev);
  };

  const displayedChats = (() => {
    if (!hasMultipleChats) return chatRooms;
    if (isExpanded) return chatRooms;

    const primaryChat = reviewChats[0] ?? chatRooms[0];
    return primaryChat ? [primaryChat] : [];
  })();

  return (
    <>
      {displayedChats.map((chat) => (
        <ChatItem
          key={chat.chatRoomId}
          chat={chat}
          tradingPhotoCardId={tradingPhotoCard.tradingPhotoCardId}
          requestChatCount={requestChatCount}
        />
      ))}

      {hasMultipleChats && (
        <div className="px-[12px] py-[8px]">
          <LoadMore
            text={
              <p className="text-[13px] text-text-main-lv2">
                {isExpanded
                  ? t('NewTradingPhotoCardMarket.collapse')
                  : t('NewTradingPhotoCardMarket.loadMore')}
              </p>
            }
            icon={
              <ChevronDownSmall
                size={12}
                className={`text-text-main-lv2 transition-transform duration-200 ${
                  isExpanded ? 'rotate-180' : ''
                }`}
              />
            }
            onClick={handleLoadMoreClick}
          />
        </div>
      )}
    </>
  );
};

export default ChatList;
